import Api from "../apiService";

class ordersApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/orders`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, orderId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/orders/${orderId}`,
      params,
      Api.authHeaders()
    );
  }

  create(companyId, orderData) {
    return Api.postRequest(
      `companies/${companyId}/orders`,
      orderData,
      Api.authHeaders()
    );
  }

  update(companyId, orderId, orderData) {
    return Api.patchRequest(
      `companies/${companyId}/orders/${orderId}`,
      orderData,
      Api.authHeaders()
    );
  }

  finishCreation(companyId, orderId, data = {}) {
    return Api.postRequest(
      `companies/${companyId}/orders/${orderId}/finish_creation`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/orders/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/orders/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }

  export(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/orders/export`,
      params,
      Api.authHeaders(),
      { responseType: "blob" } // важно для получения файла
    );
  }

  duplicate(companyId, id, params = {}) {
    return Api.postRequest(
      `companies/${companyId}/orders/${id}/duplicate`,
      params,
      Api.authHeaders()
    );
  }

  recalculate(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/orders/recalculate`,
      data,
      Api.authHeaders()
    );
  }
}

export default new ordersApi();
